import axios from "@/api/axiosInstance";
import {
  FetchVouchersReportParams,
  FetchVouchersReportResponse,
} from "./types";

export const fetchVouchersReport = async (
  params: FetchVouchersReportParams = {},
): Promise<FetchVouchersReportResponse> => {
  const response = await axios.get<FetchVouchersReportResponse>(
    "/api/private/reports/vouchers",
    { params },
  );
  return response.data;
};
